var Environment;
(function (Environment) {
    Environment["Namespace"] = "environment";
    Environment["PruNamespace"] = "_pru_environment";
})(Environment || (Environment = {}));
var build = typeof process !== "undefined" ? process.env : {};
var activeEnvironment;
var runtime;
if (Environment.Namespace in window) {
    runtime = window[Environment.Namespace];
    activeEnvironment = Environment.Namespace;
}
else if (Environment.PruNamespace in window) {
    runtime = window[Environment.PruNamespace];
    activeEnvironment = Environment.PruNamespace;
}
function isEnvironment() {
    return (activeEnvironment && (activeEnvironment === Environment.Namespace || activeEnvironment === Environment.PruNamespace));
}
var environment = Object.assign({}, build, runtime);
export { environment, isEnvironment };
//# sourceMappingURL=environment.js.map